<template>
    <article
        v-for="(feature, featureIndex) in FeaturedProductsList"
        :key="feature.key"
        class="pa-6 section-border-y"
    >
        <v-row no-gutters>
            <v-col>
                <h2
                    class="text-center text-uppercase font-size-5 letter-spacing-5 font-weight-bold py-0 my-0"
                >
                    {{ feature.title }}
                </h2>
            </v-col>
        </v-row>
        <ContainerContent>
            <template
                v-if="!isMobile && feature.useCarousel && feature.items.length > 3"
            >
                <v-carousel
                    v-model="carouselModels[featureIndex]"
                    color="secondary"
                    height="auto"
                    hide-delimiters
                    hide-delimiter-background
                >
                    <template #prev="{ props }">
                        <SliderButton
                            type="prev"
                            alt="Previous Slide"
                            :opacity="0.8"
                            v-bind="props"
                        ></SliderButton>
                    </template>
                    <template #next="{ props }">
                    <SliderButton
                            type="next"
                            alt="Next Slide"
                            :opacity="0.8"
                            v-bind="props"
                        ></SliderButton>
                    </template>
                    <v-carousel-item
                        v-for="(chunk, index) in lo_chunk(feature.items, 3)"
                        :key="index"
                    >
                        <v-row>
                            <v-col
                                v-for="(item, index) in chunk"
                                :key="index"
                                cols="12"
                                md="4"
                            >
                                <v-card
                                    :to="item.path"
                                    elevation="2"
                                    :aria-label="item.title"
                                >
                                    <v-img
                                        :src="item.imageUrl ?? getResourceCdnUrl(item.image)"
                                        :aspect-ratio="itemAspectRatio"
                                        :alt="feature.title"
                                        :class="item.imgClass ?? ''"
                                        :position="item.imgPosition ?? void(0)"
                                        :cover="item.imgCover"
                                    ></v-img>
                                </v-card>
                                <NuxtLink
                                    :to="item.path"
                                    class="no-style-link d-block text-center text-uppercase font-size-6 letter-spacing-5 font-weight-bold mt-4"
                                    :title="item.altText"
                                    :aria-label="item.title"
                                >
                                    {{ item.title }}
                                </NuxtLink>
                            </v-col>
                        </v-row>
                    </v-carousel-item>
                </v-carousel>
            </template>
            <v-row
                v-else
            >
                <v-col
                    v-for="(item, index) in feature.items"
                    :key="index"
                    cols="12"
                    md="4"
                >
                    <v-card
                        :to="item.path"
                        elevation="2"
                        :aria-label="item.title"
                    >
                        <v-img
                            :src="item.imageUrl ?? getResourceCdnUrl(item.image)"
                            :aspect-ratio="itemAspectRatio"
                            :alt="feature.title"
                            :class="item.imgClass ?? ''"
                            :position="item.imgPosition ?? void(0)"
                            :cover="item.imgCover"
                        ></v-img>
                    </v-card>
                    <NuxtLink
                        :to="item.path"
                        class="no-style-link d-block text-center text-uppercase font-size-6 letter-spacing-5 font-weight-bold mt-4"
                        :title="item.altText"
                        :aria-label="item.title"
                    >
                        {{ item.title }}
                    </NuxtLink>
                </v-col>
            </v-row>
        </ContainerContent>
    </article>
</template>

<script lang="ts" setup>
    import { FeaturedProductsList } from '~/models';
    import { useIsMobile } from '~/composables';
    import {
        useCdnResource
    } from 'x1-base/composables';
    import { chunk as lo_chunk } from 'es-toolkit/compat';

    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';
    import SliderButton from '~/components/carousel/SliderButton/SliderButton.vue';

    defineProps({
        itemAspectRatio: {
            type: Number,
            default: 1
        }
    });

    const { isMobile } = useIsMobile();
    const useCdnResourceObj = useCdnResource();
    const { getResourceCdnUrl } = useCdnResourceObj;

    const carouselModels = ref([]);
</script>

<style lang="scss"></style>
